
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $3fd478c87df3fc42$exports = {};

$parcel$export($3fd478c87df3fc42$exports, "initTheadAttributes", function () { return $3fd478c87df3fc42$export$8c232f4431fa1386; });
$parcel$export($3fd478c87df3fc42$exports, "initCellAttributes", function () { return $3fd478c87df3fc42$export$95460454ff19d469; });
$parcel$export($3fd478c87df3fc42$exports, "renderRows", function () { return $3fd478c87df3fc42$export$8aae65d4bebb157c; });
$parcel$export($3fd478c87df3fc42$exports, "addRow", function () { return $3fd478c87df3fc42$export$40ed00dbc18f8b2f; });
$parcel$export($3fd478c87df3fc42$exports, "updateRow", function () { return $3fd478c87df3fc42$export$b8d76db28fea00ae; });
const $77b5f2cf1b319760$export$5191b7f1a2859b33 = {
    ADD: "add",
    UPDATE: "update",
    DELETE: "delete",
    SORT: "sort"
};
const $77b5f2cf1b319760$export$5bd128c043787deb = {
    MAX_AGE: 90,
    MIN_AGE: 18,
    MIN_NAME_LENGTH: 4,
    MIN_SALARY: 0
};
const $77b5f2cf1b319760$export$3d748083cb7ef6c4 = {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning"
};
const $77b5f2cf1b319760$export$c5db1fed33dc7d0b = "age";
const $77b5f2cf1b319760$export$7c22e256b97d4f33 = "salary";
const $77b5f2cf1b319760$export$6b9e7cecf28b64e8 = [
    $77b5f2cf1b319760$export$c5db1fed33dc7d0b,
    $77b5f2cf1b319760$export$7c22e256b97d4f33
];
const $77b5f2cf1b319760$export$6e386ac144cffab5 = "asc";
const $77b5f2cf1b319760$export$f634ff5a7f1c8f3 = "desc";
const $77b5f2cf1b319760$export$f9ba527e25c2bc92 = {
    NAME: "name",
    POSITION: "position",
    OFFICE: "office",
    AGE: "age",
    SALARY: "salary",
    ID: "id"
};
const $77b5f2cf1b319760$export$e6d6c3d190bf100b = [
    $77b5f2cf1b319760$export$f9ba527e25c2bc92.NAME,
    $77b5f2cf1b319760$export$f9ba527e25c2bc92.POSITION,
    $77b5f2cf1b319760$export$f9ba527e25c2bc92.OFFICE,
    $77b5f2cf1b319760$export$f9ba527e25c2bc92.AGE,
    $77b5f2cf1b319760$export$f9ba527e25c2bc92.SALARY
];
const $77b5f2cf1b319760$export$79b91d4669dcadcb = {
    NAME: "Name",
    POSITION: "Position",
    OFFICE: "Office",
    AGE: "Age",
    SALARY: "Salary"
};
const $77b5f2cf1b319760$export$217fe887316b1639 = {
    TOKYO: "Tokyo",
    SINGAPORE: "Singapore",
    LONDON: "London",
    NEW_YORK: "New York",
    EDINBURGH: "Edinburgh",
    SAN_FRANCISCO: "San Francisco"
};


const $3fd478c87df3fc42$export$8c232f4431fa1386 = (theadElement, orderFields)=>{
    const tr = document.createElement("tr");
    orderFields.forEach((column)=>{
        const th = document.createElement("th");
        th.textContent = column[0].toUpperCase() + column.slice(1);
        th.dataset.field = column;
        th.tabIndex = 0;
        th.setAttribute("role", "button");
        tr.appendChild(th);
    });
    theadElement.innerHTML = "";
    theadElement.appendChild(tr);
};
const $3fd478c87df3fc42$export$95460454ff19d469 = (tbody, rows, orderFields)=>{
    const frag = document.createDocumentFragment();
    [
        ...rows
    ].forEach((row, index)=>{
        const tr = document.createElement("tr");
        tr.dataset.id = index;
        [
            ...row.children
        ].forEach((td, idx)=>{
            const elementTd = document.createElement("td");
            elementTd.textContent = td.textContent;
            elementTd.dataset.field = orderFields[idx];
            tr.appendChild(elementTd);
        });
        frag.appendChild(tr);
    });
    tbody.innerHTML = "";
    tbody.appendChild(frag);
};
const $3fd478c87df3fc42$export$8aae65d4bebb157c = (tbody, employeesArr = [], orderFields)=>{
    const frag = document.createDocumentFragment();
    employeesArr.forEach((employeeObj)=>{
        const tr = $3fd478c87df3fc42$export$40ed00dbc18f8b2f(employeeObj, orderFields);
        tr.dataset.id = employeeObj.id;
        frag.appendChild(tr);
    });
    tbody.innerHTML = "";
    tbody.appendChild(frag);
};
const $3fd478c87df3fc42$export$40ed00dbc18f8b2f = (payload, orderFields, tbody = null)=>{
    const tr = document.createElement("tr");
    orderFields.forEach((field)=>{
        const td = document.createElement("td");
        if (field === (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).SALARY) td.textContent = "$" + payload[field].toLocaleString("en-US");
        else td.textContent = payload[field];
        td.dataset.field = field;
        tr.appendChild(td);
    });
    if (tbody) tbody.appendChild(tr);
    return tr;
};
const $3fd478c87df3fc42$export$b8d76db28fea00ae = (payload, tbody)=>{
    const td = tbody.querySelector(`[data-id="${payload.id}"]`)?.querySelector(`[data-field="${payload.field}"]`);
    if (td) td.textContent = payload.field === (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).SALARY ? "$" + payload.value.toLocaleString("en-US") : payload.value;
};




const $f97d2fb75ac5f261$export$2670b72d61fe3dbe = (v)=>{
    let s = String(v ?? "").trim().replace(/\s+/g, "").replace(/['\u2019]/g, "");
    if (s === "") return s;
    const sign = s[0] === "-" ? "-" : "";
    if (sign) s = s.slice(1);
    const hasComma = s.includes(",");
    const hasDot = s.includes(".");
    s = hasComma ? s.split(",").filter(Boolean).join(",") : s;
    s = hasDot ? s.split(".").filter(Boolean).join(".") : s;
    if (hasComma && hasDot) {
        // last character is a fractional  separator
        const lastComma = s.lastIndexOf(",");
        const lastDot = s.lastIndexOf(".");
        if (lastComma > lastDot) // fractional comma
        s = s.replace(/\./g, "").replace(/,/g, ".");
        else // fractional point
        s = s.replace(/,/g, "");
        return sign + s;
    }
    if (hasComma && !hasDot) {
        const parts = s.split(",");
        const lastPart = parts[parts.length - 1];
        if (lastPart.length === 3) s = s.replace(/,/g, "");
        else s = s.replace(/,/g, ".");
        return sign + s;
    }
    if (hasDot && !hasComma) {
        const parts = s.split(".");
        if (parts.length > 1) {
            const last = parts.pop();
            if (last.length === 3) // all points are thousands
            s = parts.join("") + last;
            else // the last one is fractional
            s = parts.join("") + "." + last;
        }
        return sign + s;
    }
    return sign + s;
};


const $a5c40e99a49cefa9$var$required = (msg = "field is required")=>{
    return (v)=>v === null || v === undefined || String(v) === "" ? msg : null;
};
const $a5c40e99a49cefa9$var$minLen = (len, msg = `min length is ${len}`)=>{
    return (v)=>String(v || "").trim().length >= len ? null : msg;
};
const $a5c40e99a49cefa9$var$isInteger = (msg = "must be an integer")=>{
    return (v)=>{
        if (v === "" || v === null) return null;
        const n = Number(String(v).trim());
        return Number.isFinite(n) && Number.isInteger(n) ? null : msg;
    };
};
const $a5c40e99a49cefa9$var$inRange = (min, max, msg = `value must be between ${min} - ${max}`)=>{
    return (v)=>{
        if (v === "" || v === null) return null;
        const n = Number(String(v).trim());
        return Number.isFinite(n) && n >= min && n <= max ? null : msg;
    };
};
const $a5c40e99a49cefa9$var$isNormalizedNumber = (msg = "must be a number")=>{
    return (v)=>{
        if (v === "" || v === null) return null;
        const normalized = (0, $f97d2fb75ac5f261$export$2670b72d61fe3dbe)(v);
        const n = Number(normalized);
        return Number.isFinite(n) ? null : msg;
    };
};
const $a5c40e99a49cefa9$var$isNonNegativeNumber = (msg = "must be a positive number")=>{
    return (v)=>{
        if (v == null || v === "") return null;
        const normalized = (0, $f97d2fb75ac5f261$export$2670b72d61fe3dbe)(v);
        const n = Number(normalized);
        return Number.isFinite(n) && n >= 0 ? null : msg;
    };
};
const $a5c40e99a49cefa9$var$inList = (list, msg = `Incorrect option`)=>{
    if (Array.isArray(list)) return (v)=>list.includes(v) ? null : msg;
    return (v)=>Object.values(list).includes(v) ? null : msg;
};
const $a5c40e99a49cefa9$export$6f0adf80117cb8df = {
    name: [
        $a5c40e99a49cefa9$var$required("Name is required"),
        $a5c40e99a49cefa9$var$minLen((0, $77b5f2cf1b319760$export$5bd128c043787deb).MIN_NAME_LENGTH, `Minimum name length is ${(0, $77b5f2cf1b319760$export$5bd128c043787deb).MIN_NAME_LENGTH}`)
    ],
    position: [
        $a5c40e99a49cefa9$var$required("Position is required")
    ],
    office: [
        $a5c40e99a49cefa9$var$required("Office is required"),
        $a5c40e99a49cefa9$var$inList((0, $77b5f2cf1b319760$export$217fe887316b1639), "Invalid office name")
    ],
    age: [
        $a5c40e99a49cefa9$var$required("Age is required"),
        $a5c40e99a49cefa9$var$isInteger("Age must be an integer"),
        $a5c40e99a49cefa9$var$inRange(18, 90, "Age must be between 18 and 90")
    ],
    salary: [
        $a5c40e99a49cefa9$var$required("Salary is required"),
        $a5c40e99a49cefa9$var$isNormalizedNumber("Salary must be a valid number"),
        $a5c40e99a49cefa9$var$isNonNegativeNumber("Salary must be non negative number")
    ]
};


const $895ba1120042adaf$export$610643b94c99336e = (formData)=>{
    const errors = {};
    for (const field of Object.keys((0, $a5c40e99a49cefa9$export$6f0adf80117cb8df))){
        const validators = (0, $a5c40e99a49cefa9$export$6f0adf80117cb8df)[field];
        const fieldName = formData[field];
        for (const fn of validators){
            const err = fn(fieldName);
            if (err && !errors[field]) errors[field] = err;
        }
    }
    const valid = Object.keys(errors).length === 0;
    const cleanedData = valid ? formData : null;
    return {
        valid: valid,
        errors: errors,
        cleanedData: cleanedData
    };
};
const $895ba1120042adaf$export$7d724175a602d186 = ({ field: field, finalValue: finalValue })=>{
    const errors = (0, $a5c40e99a49cefa9$export$6f0adf80117cb8df)[field].reduce((acc, rule, idx)=>{
        const error = rule(finalValue);
        if (error) return {
            ...acc,
            [field + `_error-${idx + 1}`]: error
        };
        return {
            ...acc
        };
    }, {});
    const valid = Object.keys(errors).length === 0;
    return {
        valid: valid,
        errors: errors,
        newEmployeeField: finalValue
    };
};


const $41187d21ae41d09a$export$f7dc72e91f29c7d7 = (type, title, text = "", timeout = 4000)=>{
    const prev = document.querySelector('[data-qa="notification"]');
    if (prev) prev.remove();
    const notification = document.createElement("div");
    notification.dataset.qa = "notification";
    notification.className = `notification ${type}`;
    const h = document.createElement("h2");
    notification.appendChild(h);
    h.textContent = title;
    h.className = "title";
    if (text) {
        const p = document.createElement("p");
        p.textContent = text;
        p.style.whiteSpace = "pre-wrap";
        notification.appendChild(p);
    }
    const form = document.querySelector(".new-employee-form");
    const rect = form.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const distanceFromViewportTopToFormBottom = rect.bottom + scrollTop + "px";
    const distanceFromViewportTopToFormLeft = rect.left + "px";
    notification.style.top = distanceFromViewportTopToFormBottom;
    notification.style.left = distanceFromViewportTopToFormLeft;
    notification.style.marginTop = "10px";
    document.body.appendChild(notification);
    const t = setTimeout(()=>{
        notification.remove();
    }, timeout);
    notification.addEventListener("click", ()=>{
        clearTimeout(t);
        setTimeout(()=>notification.remove(), 150);
    });
};


const $8ab23d3e915ae694$var$commitCellEdit = (tableStore, updateEmployee)=>{
    const editor = tableStore.getActiveEditor();
    if (!editor) return;
    const { td: td, input: input, oldValue: oldValue } = editor;
    const newValue = input.value;
    if (newValue === oldValue) {
        td.textContent = oldValue;
        return;
    }
    const finalValue = typeof newValue === "string" ? newValue.trim() : newValue;
    const field = td.dataset.field;
    const { valid: valid, errors: errors } = (0, $895ba1120042adaf$export$7d724175a602d186)({
        field: field,
        finalValue: finalValue
    });
    if (!valid) {
        (0, $41187d21ae41d09a$export$f7dc72e91f29c7d7)((0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).ERROR, "Validation " + (0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).ERROR, Object.values(errors).join(". \n") + ".");
        td.textContent = oldValue;
        return;
    }
    if (valid) (0, $41187d21ae41d09a$export$f7dc72e91f29c7d7)((0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).SUCCESS, "Validation " + (0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).SUCCESS, "Employee field " + field + " updated");
    if (finalValue === "") {
        td.textContent = oldValue;
        return;
    }
    if (field === (0, $77b5f2cf1b319760$export$c5db1fed33dc7d0b) || field === (0, $77b5f2cf1b319760$export$7c22e256b97d4f33)) {
        const finalNumber = Number(finalValue);
        if (Number.isNaN(finalNumber)) {
            td.textContent = oldValue;
            return;
        }
        if (field === (0, $77b5f2cf1b319760$export$c5db1fed33dc7d0b) && (finalNumber < 18 || finalNumber > 90)) {
            td.textContent = oldValue;
            return;
        }
        td.textContent = field === (0, $77b5f2cf1b319760$export$7c22e256b97d4f33) ? "$" + finalNumber.toLocaleString("en-US") : finalNumber;
        updateEmployee(td.closest("tr").dataset.id, {
            [field]: finalNumber
        });
        return;
    }
    updateEmployee(td.closest("tr").dataset.id, {
        [field]: finalValue
    });
};
const $8ab23d3e915ae694$var$onKeyDown = (e, tableStore)=>{
    const editor = tableStore.getActiveEditor();
    if (!editor) return;
    const { td: td, input: input, oldValue: oldValue } = editor;
    if (e.key === "Enter") input.blur();
    else if (e.key === "Escape") {
        td.textContent = oldValue;
        input.blur();
    }
};
const $8ab23d3e915ae694$var$cleanup = (tableStore)=>{
    const editor = tableStore.getActiveEditor();
    if (!editor) return;
    const { handleBlur: handleBlur, handleKeyDown: handleKeyDown, input: input, td: td } = editor;
    if (input) {
        input.removeEventListener("keydown", handleKeyDown);
        input.removeEventListener("blur", handleBlur);
    }
    if (td && td.contains(input)) td.removeChild(input);
    tableStore.setActiveEditor(null);
};
const $8ab23d3e915ae694$var$onBlur = (tableStore, updateEmployee)=>{
    $8ab23d3e915ae694$var$commitCellEdit(tableStore, updateEmployee);
    $8ab23d3e915ae694$var$cleanup(tableStore);
};
const $8ab23d3e915ae694$export$c45b319a69ac01cc = (dblclickE, tableStore, updateEmployee)=>{
    const td = dblclickE.target.closest("td");
    if (!td || tableStore.getActiveEditor()) return;
    const oldValue = td.textContent;
    const input = document.createElement("input");
    input.className = "cell-input";
    if ((0, $77b5f2cf1b319760$export$6b9e7cecf28b64e8).includes(td.dataset.field)) input.type = "number";
    else input.type = "text";
    input.value = oldValue;
    td.textContent = "";
    td.appendChild(input);
    const handleBlur = ()=>{
        $8ab23d3e915ae694$var$onBlur(tableStore, updateEmployee);
    };
    const handleKeyDown = (e)=>{
        $8ab23d3e915ae694$var$onKeyDown(e, tableStore);
    };
    tableStore.setActiveEditor({
        oldValue: oldValue,
        input: input,
        td: td,
        handleBlur: handleBlur,
        handleKeyDown: handleKeyDown
    });
    input.focus();
    input.select();
    input.addEventListener("blur", handleBlur);
    input.addEventListener("keydown", handleKeyDown);
};


const $8911bd8dc1054939$var$handleTheadClick = (e, tableState, getAllEmployeesSortedBy)=>{
    const th = e.target.closest("th");
    if (!th) return;
    const field = th.dataset.field;
    if (!field) return;
    tableState.setSort(field);
    getAllEmployeesSortedBy(field, tableState.getSort().direction);
};
const $8911bd8dc1054939$var$handleTbodyClick = (e, tableState, elements)=>{
    const tr = e.target.closest("tr");
    if (!tr) return;
    if (!tableState.getSelectedRowId()) {
        tableState.setSelectedRowId(tr.dataset.id);
        tr.classList.add("active");
        return;
    }
    const prev = elements.tbody.querySelector(`tr[data-id="${tableState.getSelectedRowId()}"]`);
    if (prev) prev.classList.remove("active");
    tr.classList.add("active");
    tableState.setSelectedRowId(tr.dataset.id);
};
const $8911bd8dc1054939$export$2cd8252107eb640b = (ctx)=>{
    const { elements: elements, tableState: tableState, employeeStore: employeeStore } = ctx;
    const { update: updateEmployee, getAllSorted: getAllSortedEmployeesBy } = employeeStore;
    elements.thead.addEventListener("click", (e)=>{
        return $8911bd8dc1054939$var$handleTheadClick(e, tableState, getAllSortedEmployeesBy);
    });
    elements.tbody.addEventListener("click", (e)=>{
        return $8911bd8dc1054939$var$handleTbodyClick(e, tableState, elements);
    });
    elements.tbody.addEventListener("dblclick", (e)=>{
        return (0, $8ab23d3e915ae694$export$c45b319a69ac01cc)(e, tableState, updateEmployee);
    });
};



function $d9f31002403e4a2e$var$TableState() {
    this._sort = {
        field: null,
        direction: (0, $77b5f2cf1b319760$export$6e386ac144cffab5)
    };
    this._activeEditor = null;
    this._selectedRowId = null;
    const that = this;
    this.state = {
        getSort: ()=>that.getSort(),
        setSort: (field)=>that.setSort(field),
        getActiveEditor: ()=>that.getActiveEditor(),
        setActiveEditor: (activeEditor)=>that.setActiveEditor(activeEditor),
        getSelectedRowId: ()=>that.getSelectedRowId(),
        setSelectedRowId: (selectedRowId)=>that.setSelectedRowId(selectedRowId)
    };
}
$d9f31002403e4a2e$var$TableState.prototype = {
    constructor: $d9f31002403e4a2e$var$TableState,
    getSort () {
        return {
            ...this._sort
        };
    },
    setSort (field) {
        if (this._sort.field !== field) {
            this._sort.field = field;
            this._sort.direction = (0, $77b5f2cf1b319760$export$6e386ac144cffab5);
        } else this._sort.direction = this._sort.direction === (0, $77b5f2cf1b319760$export$6e386ac144cffab5) ? (0, $77b5f2cf1b319760$export$f634ff5a7f1c8f3) : (0, $77b5f2cf1b319760$export$6e386ac144cffab5);
    },
    getActiveEditor () {
        return this._activeEditor;
    },
    setActiveEditor (activeEditor) {
        this._activeEditor = activeEditor;
    },
    getSelectedRowId () {
        return this._selectedRowId;
    },
    setSelectedRowId (selectedRowId) {
        this._selectedRowId = selectedRowId;
    }
};
const $d9f31002403e4a2e$var$state = new $d9f31002403e4a2e$var$TableState();
const $d9f31002403e4a2e$export$a524c460c77ad0e6 = $d9f31002403e4a2e$var$state.state;



const $e3b668cc73386879$export$ed60ee4b8716ad1a = (rows, orderFields)=>{
    return Array.from(rows).map((tr)=>{
        const dataObj = Array.from(tr.children).reduce((acc, td, idx)=>{
            const key = orderFields[idx];
            const value = td.textContent.trim();
            if ((0, $77b5f2cf1b319760$export$6b9e7cecf28b64e8).includes(key)) {
                const n = Number(value);
                acc[key] = Number.isFinite(n) ? n : value;
            } else acc[key] = value;
            return acc;
        }, {});
        return dataObj;
    });
};



const $d2f2d5bf9dc20c1e$export$6ab1df3197f7c641 = (a, b, isNumeric)=>{
    if (isNumeric) return Number(a) - Number(b);
    return String(a).localeCompare(String(b), undefined, {
        sensitivity: "base"
    });
};



const $1880e38089be13fb$var$StoreProto = {
    getAll (acces) {
        return acces.getEmployees().map((emp)=>({
                ...emp
            }));
    },
    getById (acces, id) {
        return acces.getEmployees().find((emp)=>emp.id === id) || null;
    },
    add (acces, employee) {
        const newEmployee = {
            ...employee,
            id: acces.nextId()
        };
        acces.pushEmployee(newEmployee);
        acces.emitChange((0, $77b5f2cf1b319760$export$5191b7f1a2859b33).ADD, newEmployee);
        return newEmployee;
    },
    update (id, fieldValue, acces) {
        const employees = acces.getEmployees();
        const idx = employees.findIndex((emp)=>emp.id === Number(id));
        if (idx === -1) return null;
        const field = Object.keys(fieldValue)[0];
        const updated = {
            ...employees[idx],
            ...fieldValue
        };
        acces.replaceAt(idx, updated);
        acces.emitChange((0, $77b5f2cf1b319760$export$5191b7f1a2859b33).UPDATE, {
            field: field,
            value: updated[field],
            id: id
        });
    },
    remove (acces, id) {
        const idx = acces.getEmployees().findIndex((emp)=>emp.id === id);
        if (idx === -1) return false;
        acces.removeAt(idx);
        acces.emitChange();
        return true;
    },
    getAllSorted (field, direction, acces) {
        const isNumeric = (0, $77b5f2cf1b319760$export$6b9e7cecf28b64e8).includes(field);
        const sorted = acces.getEmployees().slice().sort((emp1, emp2)=>{
            const v1 = emp1[field];
            const v2 = emp2[field];
            const cmp = (0, $d2f2d5bf9dc20c1e$export$6ab1df3197f7c641)(v1, v2, isNumeric);
            return direction === (0, $77b5f2cf1b319760$export$6e386ac144cffab5) ? cmp : -cmp;
        });
        acces.emitChange((0, $77b5f2cf1b319760$export$5191b7f1a2859b33).SORT, sorted);
    },
    subscribe (acces, fn) {
        return acces.subscribe(fn);
    },
    unsubscribe (acces, fn) {
        return acces.unsubscribe(fn);
    }
};
const $1880e38089be13fb$export$65d09ed15196c7e4 = (initial = [])=>{
    const employees = initial.map((emp, idx)=>{
        return {
            ...emp,
            id: idx,
            salary: Number((0, $f97d2fb75ac5f261$export$2670b72d61fe3dbe)(emp.salary).slice(1))
        };
    });
    let idCounter = employees.reduce((max, emp)=>Math.max(max, emp.id || 0), 0);
    const listeners = new Set();
    const acces = {
        getEmployees: ()=>employees,
        pushEmployee: (emp)=>employees.push(emp),
        replaceAt: (idx, emp)=>{
            employees[idx] = emp;
        },
        removeAt: (idx)=>employees.splice(idx, 1),
        nextId: ()=>++idCounter,
        emitChange: (actionType, payload)=>{
            listeners.forEach((fn)=>{
                try {
                    fn({
                        type: actionType,
                        payload: payload
                    });
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                }
            });
        },
        subscribe: (fn)=>{
            listeners.add(fn);
            return ()=>listeners.delete(fn);
        },
        unsubscribe: (fn)=>listeners.delete(fn)
    };
    return {
        getAll: ()=>$1880e38089be13fb$var$StoreProto.getAll(acces),
        getById: (id)=>$1880e38089be13fb$var$StoreProto.getById(acces, id),
        add: (employee)=>$1880e38089be13fb$var$StoreProto.add(acces, employee),
        update: (id, fieldValue)=>$1880e38089be13fb$var$StoreProto.update(id, fieldValue, acces),
        remove: (id)=>$1880e38089be13fb$var$StoreProto.remove(acces, id),
        getAllSorted: (field, direction)=>$1880e38089be13fb$var$StoreProto.getAllSorted(field, direction, acces),
        subscribe: (fn)=>$1880e38089be13fb$var$StoreProto.subscribe(acces, fn),
        unsubscribe: (fn)=>$1880e38089be13fb$var$StoreProto.unsubscribe(acces, fn)
    };
};






const $2588dbeaa6e2da12$var$SCHEMA = [
    {
        name: (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).NAME,
        label: (0, $77b5f2cf1b319760$export$79b91d4669dcadcb).NAME
    },
    {
        name: (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).POSITION,
        label: (0, $77b5f2cf1b319760$export$79b91d4669dcadcb).POSITION
    },
    {
        name: (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).OFFICE,
        label: (0, $77b5f2cf1b319760$export$79b91d4669dcadcb).OFFICE
    },
    {
        name: (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).AGE,
        label: (0, $77b5f2cf1b319760$export$79b91d4669dcadcb).AGE
    },
    {
        name: (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).SALARY,
        label: (0, $77b5f2cf1b319760$export$79b91d4669dcadcb).SALARY
    }
];
const $2588dbeaa6e2da12$var$normalizeFormData = (cleanedData)=>{
    return {
        [(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).NAME]: cleanedData[(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).NAME].trim(),
        [(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).POSITION]: cleanedData[(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).POSITION].trim(),
        [(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).OFFICE]: cleanedData[(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).OFFICE].trim(),
        [(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).AGE]: Number(cleanedData[(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).AGE]),
        [(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).SALARY]: Number((0, $f97d2fb75ac5f261$export$2670b72d61fe3dbe)(cleanedData[(0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).SALARY]))
    };
};
const $2588dbeaa6e2da12$var$onSubmitForm = (e, addEmployee)=>{
    e.preventDefault();
    const FORM_DATA = (0, $77b5f2cf1b319760$export$e6d6c3d190bf100b).reduce((acc, k)=>{
        acc[k] = document.querySelector(`[name="${k}"]`).value.trim();
        return acc;
    }, {});
    const { valid: valid, errors: errors, cleanedData: cleanedData } = (0, $895ba1120042adaf$export$610643b94c99336e)(FORM_DATA);
    if (!valid) {
        (0, $41187d21ae41d09a$export$f7dc72e91f29c7d7)((0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).ERROR, "Validation " + (0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).ERROR, Object.values(errors).join(". \n") + ".");
        return;
    }
    if (valid) {
        (0, $41187d21ae41d09a$export$f7dc72e91f29c7d7)((0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).SUCCESS, "Validation " + (0, $77b5f2cf1b319760$export$3d748083cb7ef6c4).SUCCESS, "New employee saved");
        const employeeData = $2588dbeaa6e2da12$var$normalizeFormData(cleanedData);
        addEmployee(employeeData);
    }
};
const $2588dbeaa6e2da12$export$8f6e5b5e868af1d3 = (addEmployee)=>{
    const form = document.createElement("form");
    form.className = "new-employee-form";
    $2588dbeaa6e2da12$var$SCHEMA.forEach((field)=>{
        const label = document.createElement("label");
        form.appendChild(label);
        label.appendChild(document.createTextNode(`${field.label}: `));
        if (field.name === (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).OFFICE) {
            const select = document.createElement("select");
            select.dataset.qa = field.name;
            select.required = true;
            select.name = field.name;
            const placeholder = document.createElement("option");
            select.appendChild(placeholder);
            placeholder.value = "";
            placeholder.textContent = "Select office...";
            Object.values((0, $77b5f2cf1b319760$export$217fe887316b1639)).forEach((office)=>{
                const option = document.createElement("option");
                select.appendChild(option);
                option.textContent = office;
                option.value = office;
            });
            label.appendChild(select);
            return;
        }
        const input = document.createElement("input");
        label.appendChild(input);
        input.dataset.qa = field.name;
        input.name = field.name;
        input.required = true;
        switch(field.name){
            case (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).AGE:
                input.min = (0, $77b5f2cf1b319760$export$5bd128c043787deb).MIN_AGE;
                input.max = (0, $77b5f2cf1b319760$export$5bd128c043787deb).MAX_AGE;
                break;
            case (0, $77b5f2cf1b319760$export$f9ba527e25c2bc92).SALARY:
                input.min = (0, $77b5f2cf1b319760$export$5bd128c043787deb).MIN_SALARY;
                break;
        }
        if ((0, $77b5f2cf1b319760$export$6b9e7cecf28b64e8).includes(field.name)) input.type = "number";
        else input.type = "text";
    });
    const button = document.createElement("button");
    button.textContent = "Save to table";
    button.type = "submit";
    button.addEventListener("click", function(e) {
        // // html validation
        // if (!form.checkValidity()) {
        //   form.reportValidity();
        //   return;
        // }
        return $2588dbeaa6e2da12$var$onSubmitForm(e, addEmployee);
    });
    form.appendChild(button);
    return form;
};



const $c33544607d4b4bc3$export$2cd8252107eb640b = ()=>{
    const thead = document.querySelector("thead");
    const tbody = document.querySelector("tbody");
    const orderFields = Array.from(thead.querySelectorAll("th")).map((th)=>th.textContent[0].toLowerCase() + th.textContent.slice(1));
    $3fd478c87df3fc42$export$8c232f4431fa1386(thead, orderFields);
    const employeeStore = (0, $1880e38089be13fb$export$65d09ed15196c7e4)((0, $e3b668cc73386879$export$ed60ee4b8716ad1a)(tbody.rows, orderFields));
    const { add: add, update: update, getAllSorted: getAllSorted } = employeeStore;
    const employeeForm = (0, $2588dbeaa6e2da12$export$8f6e5b5e868af1d3)(add);
    employeeStore.subscribe(({ type: type, payload: payload })=>{
        switch(type){
            case (0, $77b5f2cf1b319760$export$5191b7f1a2859b33).UPDATE:
                $3fd478c87df3fc42$export$b8d76db28fea00ae(payload, tbody);
                break;
            case (0, $77b5f2cf1b319760$export$5191b7f1a2859b33).ADD:
                $3fd478c87df3fc42$export$40ed00dbc18f8b2f(payload, orderFields, tbody);
                break;
            case (0, $77b5f2cf1b319760$export$5191b7f1a2859b33).SORT:
                $3fd478c87df3fc42$export$8aae65d4bebb157c(tbody, payload, orderFields);
                break;
        }
    });
    const ctx = {
        tableState: $d9f31002403e4a2e$export$a524c460c77ad0e6,
        elements: {
            thead: thead,
            tbody: tbody
        },
        employeeStore: {
            update: update,
            getAllSorted: getAllSorted
        },
        render: $3fd478c87df3fc42$exports
    };
    $3fd478c87df3fc42$export$95460454ff19d469(tbody, tbody.rows, orderFields);
    document.body.appendChild(employeeForm);
    $8911bd8dc1054939$export$2cd8252107eb640b(ctx);
};


"use strict";
(0, $c33544607d4b4bc3$export$2cd8252107eb640b)();


//# sourceMappingURL=index.d55316db.js.map
